export default "/images/68d8348d79b4791e61a0a44ec7238649.avif";